function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#757575;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-18.947)"
}, React.createElement("g", {
  transform: "translate(52.18 14.297)"
}, React.createElement("circle", {
  className: "a",
  cx: 7.403,
  cy: 7.403,
  r: 7.403
})), React.createElement("g", {
  transform: "translate(32.728 8.497)"
}, React.createElement("path", {
  className: "a",
  d: "M152.684,107.677C141.7,93.913,142.494,94.851,141.991,94.44L136.915,73.8l14.565-19.773a3.572,3.572,0,1,0-5.752-4.237L131.006,69.779c-.073.014-.146.03-.218.048-9.423,2.317-8.838,2.156-9.277,2.326L103.464,53.78a3.572,3.572,0,0,0-5.1,5.006l20.506,20.875,5.672,23.063-1.654,5.854-14.431-2.554a4.286,4.286,0,1,0-1.494,8.441l18.249,3.23a4.286,4.286,0,0,0,4.872-3.056c4.1-14.5,3.836-13.482,3.9-14.028l1.764-.434c.179.261-.549-.662,8.019,10.07L133,122.758a4.286,4.286,0,1,0,6.5,5.593l13.09-15.2A4.287,4.287,0,0,0,152.684,107.677Z",
  transform: "translate(-97.344 -48.338)"
})), React.createElement("g", {
  transform: "translate(92.935 15.39)"
}, React.createElement("path", {
  className: "a",
  d: "M446.764,87.55a2.441,2.441,0,0,0-2.233,1.457,2.442,2.442,0,0,0-4.676.986c0,2.647,3.387,5.313,4.4,6.048a.475.475,0,0,0,.56,0c1.009-.735,4.4-3.4,4.4-6.047A2.442,2.442,0,0,0,446.764,87.55Z",
  transform: "translate(-439.855 -87.55)"
})), React.createElement("g", {
  transform: "translate(29.418 33.172)"
}, React.createElement("path", {
  className: "a",
  d: "M85.427,188.713a2.442,2.442,0,0,0-2.233,1.457,2.442,2.442,0,0,0-4.676.986c0,2.647,3.387,5.313,4.4,6.048a.475.475,0,0,0,.56,0c1.009-.735,4.4-3.4,4.4-6.047A2.442,2.442,0,0,0,85.427,188.713Z",
  transform: "translate(-78.518 -188.713)"
})), React.createElement("g", {
  transform: "translate(18.947 18.108)"
}, React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("path", {
  className: "a",
  d: "M24.515,103.015a1.967,1.967,0,0,0-1.8,1.174,1.968,1.968,0,0,0-3.768.794c0,2.133,2.73,4.281,3.542,4.874a.383.383,0,0,0,.451,0c.813-.592,3.542-2.74,3.542-4.873A1.968,1.968,0,0,0,24.515,103.015Z",
  transform: "translate(-18.947 -103.015)"
}))), React.createElement("g", {
  transform: "translate(34.094)"
}, React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("path", {
  className: "a",
  d: "M110.684,0a1.967,1.967,0,0,0-1.8,1.174,1.968,1.968,0,0,0-3.768.794c0,2.133,2.73,4.281,3.542,4.873a.383.383,0,0,0,.451,0c.813-.592,3.542-2.74,3.542-4.873A1.968,1.968,0,0,0,110.684,0Z",
  transform: "translate(-105.116)"
}))), React.createElement("g", {
  transform: "translate(89.186 0.812)"
}, React.createElement("path", {
  className: "a",
  d: "M422.79,4.62a1.5,1.5,0,0,1-2.754,0,1.506,1.506,0,0,0-1.506,1.506c0,1.632,2.088,3.276,2.71,3.729a.292.292,0,0,0,.345,0c.622-.453,2.71-2.1,2.71-3.728A1.506,1.506,0,0,0,422.79,4.62Z",
  transform: "translate(-418.53 -4.62)"
})), React.createElement("g", {
  transform: "translate(69.178 6.103)"
}, React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("path", {
  className: "a",
  d: "M308.966,34.717a1.5,1.5,0,0,1-2.754,0,1.506,1.506,0,0,0-1.506,1.506c0,1.632,2.088,3.276,2.71,3.729a.293.293,0,0,0,.345,0c.622-.453,2.71-2.1,2.71-3.728A1.506,1.506,0,0,0,308.966,34.717Z",
  transform: "translate(-304.706 -34.717)"
}))));

var SvgPassionImg = function SvgPassionImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 83.339,
    height: 90,
    viewBox: "0 0 83.339 90",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPassionImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passion_img.3b7530ba.svg";
export { ForwardRef as ReactComponent };